'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style", "side"];
import * as React from 'react';
import { useStableCallback } from '@base-ui/utils/useStableCallback';
import { useRenderElement } from '@mui/x-scheduler-internals/base-ui-copy';
import { useEventResizeHandler } from '@mui/x-scheduler-internals/internals';
import { useTimelineGridEventContext } from "../event/TimelineGridEventContext.mjs";
export const TimelineGridEventResizeHandler = /*#__PURE__*/React.forwardRef(function TimelineGridEventResizeHandler(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      side
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // Context hooks
  const contextValue = useTimelineGridEventContext();

  // Ref hooks
  const ref = React.useRef(null);

  // Feature hooks
  const getDragData = useStableCallback(input => _extends({}, contextValue.getSharedDragData(input), {
    source: 'TimelineGridEventResizeHandler',
    side
  }));
  const {
    state,
    enabled
  } = useEventResizeHandler({
    ref,
    side,
    contextValue,
    getDragData
  });
  return useRenderElement('div', componentProps, {
    enabled,
    state,
    ref: [forwardedRef, ref],
    props: [elementProps]
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridEventResizeHandler.displayName = "TimelineGridEventResizeHandler";